import { cn } from "@/shared/lib/cn";

interface DividerProps {
  /** Optional text centered on the divider line */
  text?: string;
  /** Additional className */
  className?: string;
}

/**
 * Horizontal divider with an optional centered label.
 *
 * @example
 * ```tsx
 * <Divider />
 * <Divider text="Or" />
 * <Divider text="Or continue with" />
 * ```
 */
export function Divider({ text, className }: DividerProps) {
  if (!text) {
    return <hr className={cn("border-gray-200", className)} />;
  }

  return (
    <div aria-label={text} className={cn("relative", className)} role="separator">
      <div aria-hidden="true" className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-gray-200" />
      </div>
      <div aria-hidden="true" className="relative flex justify-center text-sm">
        <span className="bg-white px-4 text-gray-600">{text}</span>
      </div>
    </div>
  );
}
